export default __webpack_public_path__ + "static/media/password-theft.72ce1a25.svg";